// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-icon[data-v-063d1a9c]{fill:currentColor}.storke[data-v-063d1a9c]{stroke:currentColor}", ""]);
// Exports
module.exports = exports;
